export default "__VITE_ASSET__DywRqPu5__"